<template>
  <div id="contact_us_page">
    <header-section></header-section>
    <loading-modal v-if="this.show_loadding_api"></loading-modal>
    <div class="container">      
      <div class="content-section row">
        <div class="col-md-6">
          <div class="data_container data_fields">
            <div class="title-section">
              Để lại thông tin - MoraNow sẽ liên hệ bạn sớm nhất có thể!
            </div>
            <div class="data_field">
              <span> Tên của bạn (bắt buộc)</span>
              <input v-model="info.name" class="col-md-10 form-control" type='text'>  
            </div>
            <div class="data_field">
              <span> Email (bắt buộc)</span>
              <input v-model="info.email" class="col-md-10 form-control" type='text'>  
            </div>
            <div class="data_field">
              <span> Số điện thoại (bắt buộc)</span>
              <input v-model="info.phone" class="col-md-10 form-control" type='text'>  
            </div>
            <div class="data_field">
              <span> Câu hỏi</span>
              <textarea v-model="info.question" class="col-md-10 form-control" type='text'></textarea>
            </div>           
            <button @click="contact_us()" class="contact_us btn btn-default">Gửi đi</button>
          </div>
        </div>
        <div class="col-md-6">
          <div class="data_container data_info">
            <div class="basic-info">
              <div class="title-section">
                Thông tin liên hệ
              </div>
              <div class="basic-info-element">
                <i class="fa fa-map-marker"></i> 
                <span>Số 19 ngõ 192 Thái Thịnh, Đống Đa, Hà Nội</span>
              </div>
              <div class="basic-info-element">
                <i class="fa fa-phone"></i>
                <span>Call Us : 0822160262</span>
              </div>
              <div class="basic-info-element">
                <i class="fa fa-envelope"></i>
                <span> Email : info@moranow.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>
<script>
var url = process.env.API_URL + process.env.API_VERSION;
import HeaderSection from "./components/Common/HeaderSection.vue";
import LoadingModal from "./components/Modal/LoadingModal.vue";
  export default{
    components:{
      HeaderSection,
      LoadingModal
    },
    data: function(){
      return{
        info:{
          name:     '',
          email:    '',
          phone:    '',
          question: ''
        },
        show_loadding_api: false
      }
    },
    methods:{
      contact_us(){
        this.show_loadding_api = true
        this.$http.post(url + '/contact/create',
          {contact_info: this.info}
        )
        .then((response) =>{
          this.show_loadding_api = false
          alert('Thông tin liên hệ của bạn đã được gửi đi')
        })
        .catch((errors) => {
          this.show_loadding_api = false
          if (errors.response != undefined){
            alert(errors.response.data.message)
          }else{
            alert('Có lỗi xảy ra, vui lòng liên hệ lại')
          }          
        })

      }
    }

  };
</script>
<style lang="scss" scoped>
  @import "./components/Common/contact_us.scss"
</style>


// WEBPACK FOOTER //
// src/views/ContactUs.vue